<template>
    <div class="text-subtitle-2 font-weight-bold">
        <span>
            {{ Object.keys(tariff).length > 1 ? Object.keys(tariff).join(' + ') : Object.keys(tariff)[0] }}
        </span>
        /
        {{ allClasses }}
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class FlightTariffLabel extends Vue {
        @Prop() tariff

        get allClasses() {
            const classes = new Set([])
            Object.values(this.tariff).forEach(tarif => {
                tarif.classes.forEach(classType => {
                    classes.add(classType)
                })
            })
            return Array.from(classes).join(' + ')
        }
    }

    export default FlightTariffLabel
</script>
